/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// material
import { Control, ImageUploader } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'material/community/placeholderimages/placeholderimages_styles';
// actions
import { uploadCommentingImage, discardImage } from 'state/actions/commentingState/addOnsStatus';



/* ========== ~~~~~~~~~~ ADD-ON COMMUNITY TOP ARTICLES : PLACEHOLDER IMAGES ~~~~~~~~~~ ========== */
const PlaceholderImages = props => {
    const placeholderImageUploading = useSelector(({ commentingState }) => commentingState.addOnsStatus.isUploadingImage);
    const commentingUnitUUID = useSelector(({commentingState}) => commentingState.configStatus.commentingUnitUUID);

    const dispatch = useDispatch();

    const handleUploadImage = (blob) => {
        dispatch(uploadCommentingImage(commentingUnitUUID, blob, props.type, props.onChange));
    }

    const discardCommunityImage = () => {
        dispatch(discardImage(props.type));
        props.onChange(null);
    }

    return (
        <div className={`placeholderimages ${props.classes.placeholderimages} section`}>
            <div className={`sectioncontent`}>
                <Control 
                    text={'Standard'} 
                    value={'standard'} 
                    handleSelect={props.handleSelect} 
                    variant={'secondary'} 
                    addCheckWhenSelected={true}
                    selected={!props.selectedPlaceholderImageType ? true : props.selectedPlaceholderImageType === 'standard'}  
                />
                <Control 
                    text={'Custom'} 
                    value={'custom'}
                    handleSelect={props.handleSelect} 
                    variant={'secondary'} 
                    addCheckWhenSelected={true}
                    selected={props.selectedPlaceholderImageType === 'custom'}  
                />
                { props.selectedPlaceholderImageType === 'custom' &&
                    <ImageUploader 
                        fileName={props.fileName}
                        uploadImage={handleUploadImage} 
                        uploading={placeholderImageUploading}
                        imageSrc={props.placeholderImageUrl}
                        discardFile={() => discardCommunityImage()} 
                        maxWidth={5000} 
                        maxHeight={5000} 
                        maxSize={5000} 
                        supportedFileTypes={["image/jpeg","image/png","image/gif"]} 
                    />
                }
            </div>
        </div>
    )
}

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(PlaceholderImages);